// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3yKEa","alertIcon":"ConfirmModal_alertIcon__1evr4"};